export default {
  'YouTube and High Definition Videos': 'YouTube et vidéos en haute définition',
  'Story videos (Instagram/Snaps/TikTok)': 'Vidéos des histoires (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Vidéos de Facebook et Instagram Feed',
  'Facebook and Twitter Portrait Videos': 'Vidéos de portraits sur Facebook et Twitter',
  'Twitter and Facebbok Landscape Videos': 'Vidéos de paysages sur Twitter et Facebbok',
  'Facebook Cover Videos And Blog Banners': 'Vidéos de couverture Facebook et bannières de blog',
  'Fit': 'Ajustement',
  'Fill': 'Remplir',
}